var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('material-element',{attrs:{"shopConfig":_vm.shopConfig,"value":_vm.material,"disabled":_vm.disabled,"thicknesses":_vm.thicknesses},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }